import React from "react"

import { Decorator } from "components"

import Card from "./_Card"
import KeyLines from "./_Keylines"
import PseudoBackground from "./_PseudoBackground"

function CareerGrid({ careerCategories, decorators }) {
  if (careerCategories && careerCategories[0])
    return (
      <section data-slice="CareerGrid" className="relative wrapper">
        <div className="pb-0 pt-14 lg:pt-0 lg:pb-32 default-grid">
          <PseudoBackground />
          <div className="relative row-span-1 row-start-1 pb-14 md:pb-26 col-span-full lg:col-span-9 lg:col-start-4">
            <div className="absolute block w-40 h-px -left-6 sm:-left-fluidMargin -top-10 lg:hidden bg-mineralGray" />
            <div className="absolute top-0 bottom-0 -left-6 -right-6 md:-left-26 md:-right-26">
              <KeyLines />
            </div>
            <ul className="grid-cols-2 default-grid lg:grid-cols-3">
              {careerCategories?.map((card, i) => (
                <Card {...card} index={i} key={`card--${i}`} />
              ))}
            </ul>
          </div>
        </div>
        {decorators && decorators[0] && (
          <Decorator
            className="absolute top-0 left-0 hidden -translate-x-1/2 translate-y-12 lg:block"
            asset={decorators && decorators[0].asset}
            size="large"
          />
        )}
        {decorators && decorators[1] && (
          <Decorator
            className="absolute bottom-0 right-0 hidden -translate-y-4 -translate-x-1/3 lg:block"
            asset={decorators && decorators[1].asset}
            size="small"
          />
        )}
      </section>
    )
  else return null
}

export default CareerGrid
